import type { Media } from "./content";

export type ItemFeedbackEntry = {
	type: "static" | "dynamic";
	brief: string | null;
	detailed?: {
		text: string;
		media?: Media[];
	};
	language: string;
};

export type ItemFeedback = ItemFeedbackEntry[];
